module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Transport.5d3f3fe5-ps.jpg";